<template>
  <div>
    <!-- wordkomngg <br />
    asdasdsad -->
    <!-- v-if="type == 'content'" -->
    <div
      class="history-detail-wrapper"
      style="padding: 20px; background: #fff"
    >
      <div id="history-detail">
        <div class="rcpt-header">
          <div
            class="rcpt-check"
            :class="`rcpt-${item.current_status}`"
          >
            <v-icon
              color="white"
              large
            >
              {{ icons[item.current_status] }}
            </v-icon>
          </div>
          <div class="rcpt-title text-capitalize">
            Session {{ item.current_status.replace(/_/g, " ") }}
          </div>
          <div
            v-if="item.booking_id"
            class="rcpt-id"
          >
            Booking No: {{ item?.booking_id }}
          </div>
          <div
            v-else
            class="rcpt-id"
          >
            Walking Customer
          </div>
          <div class="rcpt-date">
            {{
              item.booking_date ||
              item?.charge_session?.completed_at | formatDate("DD-MMM-YYYY")
            }}
          </div>
        </div>

        <!--  -->
        <!-- Stats bar -->
        <div class="live-stats">
          <div class="live-stat">
            <div class="live-stat__val">
              {{ item?.charge_session?.energy_consumed || 0
              }}<span class="live-stat__unit"> kWh</span>
            </div>
            <div class="live-stat__lbl">
              Energy Delivered
            </div>
          </div>
          <div class="live-stat">
            <div class="d-flex justify-center gap5">
              <div class="live-stat__val">
                {{ item?.charge_session?.start_soc || 0 }}% →
                {{ item?.charge_session?.end_soc || 0 }}%
                <!-- <span class="live-stat__unit"> {{ r.unit }}</span> -->
              </div>
            </div>
            <div class="live-stat__lbl">
              Start → End SOC
            </div>
          </div>
          <div
            v-if="isSession"
            class="live-stat"
          >
            <div class="d-flex justify-center gap5">
              <div
                v-for="(r, i) in convertDuration(
                  item?.charge_session?.duration_minutes
                )"
                :key="i"
                class="live-stat__val"
              >
                {{ r.value }}
                <span class="live-stat__unit"> {{ r.unit }}</span>
              </div>
            </div>
            <div class="live-stat__lbl">
              Session Duration
            </div>
          </div>
          <div
            v-if="item?.booking_id"
            class="live-stat"
          >
            <div class="live-stat__val">
              {{ item?.slot_duration_minutes }}
              <span class="live-stat__unit">min </span>
            </div>
            <div class="live-stat__lbl">
              Booking Duration
            </div>
          </div>
          <div class="live-stat">
            <div class="live-stat__val">
              {{ item?.co2Saved || 0 }}
              <span class="live-stat__unit">kg </span>
            </div>
            <div class="live-stat__lbl">
              CO₂ Saved
            </div>
          </div>
        </div>
        <!-- stats -->
        <!-- <div class="rcpt-grid">
        <div class="rcpt-stat">
          <div class="rcpt-stat__val">
            {{ item?.charge_session?.energy_consumed || 0 }}
            <span class="rcpt-stat__unit"> kWh</span>
          </div>
          <div class="rcpt-stat__lbl">Energy Delivered</div>
        </div>
        <div class="rcpt-stat">
          <div class="rcpt-stat__val">
            {{ item?.charge_session?.start_soc || 0 }}%
            <span class="rcpt-stat__arrow"> → </span>
            {{ item?.charge_session?.end_soc || 0 }}%
          </div>
          <div class="rcpt-stat__lbl">Start → End SOC</div>
        </div>
        <div
          v-if="isSession"
          class="rcpt-stat"
        >
          <div class="d-flex justify-center">
            <div
              v-for="(r, i) in convertMinutes(
                item?.charge_session?.duration_minutes
              )"
              :key="i"
            >
              <div class="rcpt-stat__val mr-2">
                {{ r.value }}
                <span class="rcpt-stat__unit"> {{ r.unit }}</span>
              </div>
            </div>
          </div>
          <div class="rcpt-stat__lbl">Session Duration</div>
        </div>
        <div class="rcpt-stat">
          <div class="rcpt-stat__val">
            {{ item?.slot_duration_minutes }}
            <span class="rcpt-stat__unit"> min</span>
          </div>
          <div class="rcpt-stat__lbl">Booking Duration</div>
        </div>
        <div class="rcpt-stat">
          <div class="rcpt-stat__val">
            {{ item.co2Saved || 0 }}
            <span class="rcpt-stat__unit"> kg</span>
          </div>
          <div class="rcpt-stat__lbl">CO₂ Saved</div>
        </div>
      </div> -->

        <div class="rcpt-section">
          <div class="rcpt-section__title">
            Station Details
          </div>
          <div class="rcpt-row">
            <span class="rk">Station</span><span class="rv">{{ item.location_name }}</span>
          </div>
          <div class="rcpt-row">
            <span class="rk">Port</span><span class="rv">Port-{{ item.connector_no }}</span>
          </div>
          <div class="rcpt-row">
            <span class="rk">Connector</span>
            <span class="rv">
              {{ item.connector_type }}-
              {{ item.connector_power }}
            </span>
          </div>
          <div class="rcpt-row">
            <span class="rk">Start</span>
            <span class="rv">
              {{
                ["no_show", "cancelled"].includes(item.current_status)
                  ? "-"
                  : item.start_time_format ||
                    item?.charge_session?.started_at_format
              }}
            </span>
          </div>
          <div class="rcpt-row">
            <span class="rk">End</span>
            <span class="rv">
              {{
                ["no_show", "cancelled"].includes(item.current_status)
                  ? "-"
                  : item.end_time_format ||
                    item?.charge_session?.completed_at_format
              }}
            </span>
          </div>
        </div>

        <div class="rcpt-section">
          <div class="rcpt-section__title">
            Vehicle Details
          </div>
          <div class="rcpt-row">
            <span class="rk">Customer</span><span class="rv">{{ item.customer_name }}</span>
          </div>
          <div class="rcpt-row">
            <span class="rk">Vehicle</span>
            <span class="rv">
              {{ item.vehicle_make_name }}-
              {{ item.vehicle_model_name }}
            </span>
          </div>
          <div class="rcpt-row">
            <span class="rk">Reg #</span><span class="rv">{{ item.vehicle_reg_no }}</span>
          </div>
        </div>

        <div class="rcpt-section">
          <div class="rcpt-section__title">
            Payment
          </div>
          <div class="rcpt-row rcpt-row--amount">
            <span class="rk">Total Charged</span>
            <span class="rv rv--amount">
              {{ item?.charge_session?.currency || 0 }}
              {{ item?.charge_session?.total_cost || 0 }}
            </span>
          </div>
          <div class="rcpt-row">
            <span class="rk">Method</span><span class="rv text-capitalize">
              {{ item.payment_type || "-" }}
            </span>
          </div>
        </div>
      </div>
      <div
        v-if="item?.charge_session?.session_id"
        class="mt-4"
      >
        <v-btn
          color="primary"
          :loading="loading"
          class="big-btn btn-primary rcpt-dl-btn"
          @click="download"
        >
          <v-icon color="white">
            mdi-download
          </v-icon>
          Download Receipt
        </v-btn>
      </div>
    </div>
    <!-- v-else-if="type == 'download'" -->
    <!--  -->
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logo from "@/assets/brandLogo/hgl-brand-logo.png";
import { debounce } from "lodash";
/* ---------- Stats ---------- */
import { convertDuration, getDurationInMin } from "../utils/bookingHelpers";

export default {
  props: {
    type: {
      type: String,
      default() {
        return "content";
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      icons: {
        no_show: "mdi-account-off ",
        rescheduled: "mdi-clock-outline",
        approved: "mdi-check",
        completed: "mdi-check",
        cancelled: "mdi-cancel",
      },
    };
  },
  computed: {
    isSession() {
      return this.item?.charge_session ? true : false;
    },
  },

  // beforeUpdate() {
  //   this.fetchData();
  // },

  methods: {
    convertDuration,
    getDurationInMin,
    fetchData: debounce(function () {
      const params = {
        id: this.item.booking_id || this.item?.charge_session?.session_id,
      };
      this.$store.dispatch("bookingOperator/getPriceSummary", params);
      // .then((res) => {
      // });
    }, 200),
    download() {
      const params = {
        id: this.item?.charge_session?.session_id,
      };
      this.$store.dispatch("bookingOperator/downloadInvoice", params);
    },
    getBase64Image(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";

        img.onload = function () {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          resolve(canvas.toDataURL("image/png"));
        };

        img.src = url;
      });
    },
    async downloadPDF() {
      this.loading = true;

      const element = document.getElementById("history-detail");

      const canvas = await html2canvas(element, {
        scale: 1,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png", 0.5);

      const pdf = new jsPDF("p", "mm", "a4");

      const pageWidth = pdf.internal.pageSize.getWidth();

      // ===== Logo =====
      const logoData = await this.getBase64Image(logo);

      pdf.addImage(
        logoData,
        "PNG",
        10, // x
        8, // y
        32, // width
        24 // height
      );

      // ===== Heading =====
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(12);

      pdf.text("Session Receipt", pageWidth - 10, 16, {
        align: "right",
      });

      // ===== Divider =====
      pdf.setDrawColor(220);
      pdf.line(10, 26, pageWidth - 10, 26);

      // ===== Receipt Image =====
      const imgWidth = pageWidth - 20;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 10, 30, imgWidth, imgHeight);

      pdf.save(`session-receipt-${this.item.booking_id}.pdf`);

      this.loading = false;
    },
    convertMinutes(duration) {
      const result = [];
      const hours = Math.floor(duration / 60);
      const minutes = duration % 60;

      if (hours > 0) {
        result.push({
          value: hours,
          unit: "Hour",
        });
      }

      if (minutes > 0) {
        result.push({
          value: minutes,
          unit: "mins",
        });
      }

      return result;
    },
  },
};
</script>
<style scoped>
.history-detail-wrapper {
  height: 70vh;
  overflow-y: auto;
}
/* ── SESSION RECEIPT ── */
.hgl-list .rcpt-header {
  background: var(--gradient);
  border-radius: 16px;
  padding: 24px 20px 20px;
  text-align: center;
  margin-bottom: 16px;
}
.hgl-list .rcpt-check {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  /* background: #22c55e; */
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}
.rcpt-rescheduled,
.rcpt-no_show {
  background: #e6a817;
}
.rcpt-approved,
.rcpt-completed {
  background: #22c55e;
}
.rcpt-cancelled {
  background: #ea5858;
}
.hgl-list .rcpt-title {
  font-size: 18px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 4px;
}
.hgl-list .rcpt-id {
  font-size: 13px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.7);
  font-family: "Courier New", monospace;
  letter-spacing: 0.5px;
}
.hgl-list .rcpt-date {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 4px;
}
.hgl-list .rcpt-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 16px;
}

/* ---------- Stats ---------- */
.live-stats {
  /* display: flex;
  align-items: stretch;
  padding: 12px 4px;
  margin-bottom: 16px; */
  border: 1px solid var(--line);
  border-radius: 14px;
  background: #fff;
  flex-wrap: wrap !important;
}
.live-stat {
  border-right: 1px solid var(--line);
  flex: 1;
  text-align: center;
  padding: 0.5rem;
  /* min-width: none; */
}
.live-stat__val {
  /* font-size: clamp(16px, 4.5vw, 20px); */
  /* font-weight: 800; */
  color: #000;
  white-space: nowrap;
}
.live-stat__unit {
  /* font-size: 12px; */
  /* font-weight: 600; */
  color: var(--muted);
}
.live-stat__lbl {
  font-size: 11px;
  font-weight: 600;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-top: 2px;
}
.live-stat-div {
  width: 1px;
  background: var(--muted);
  margin: 2px 0;
}
/* ---------- Stats ---------- */

.hgl-list .rcpt-stat {
  background: #fff;
  border-radius: 12px;
  padding: 14px 12px;
  text-align: center;
  box-shadow: var(--shadow);
}
.hgl-list .rcpt-stat__val {
  font-size: 20px;
  font-weight: 800;
  color: var(--darkGreen);
  line-height: 1.1;
}
.hgl-list .rcpt-stat__unit {
  font-size: 12px;
  font-weight: 600;
  color: var(--muted);
}
.hgl-list .rcpt-stat__arrow {
  font-size: 14px;
  color: var(--muted);
  font-weight: 400;
}
.hgl-list .rcpt-stat__lbl {
  font-size: 11px;
  color: var(--muted);
  margin-top: 4px;
  font-weight: 600;
}
.hgl-list .rcpt-section {
  background: #fff;
  border-radius: 14px;
  padding: 14px 16px;
  box-shadow: var(--shadow);
  margin-bottom: 12px;
}
.hgl-list .rcpt-section__title {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: 10px;
}
.hgl-list .rcpt-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 0;
  font-size: 14px;
  border-bottom: 1px solid var(--line);
}
.hgl-list .rcpt-row:last-child {
  border-bottom: none;
}
.hgl-list .rk {
  color: var(--muted);
  font-weight: 500;
}
.hgl-list .rv {
  font-weight: 700;
  color: var(--t);
  text-align: right;
  max-width: 60%;
}
.hgl-list .rcpt-row--amount {
  padding: 10px 0;
}
.hgl-list .rv--amount {
  font-size: 20px;
  font-weight: 800;
  color: var(--darkGreen);
}
.hgl-list .rcpt-dl-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  gap: 8px;
}
:deep .rcpt-dl-btn .v-btn__content {
  display: flex;
  gap: 1rem;
}

@media (max-width: 1024px) {
  .live-stats {
    background: transparent;
    border: none;
    padding: 0;
    gap: 0.5rem;
  }
  .live-stat {
    background: #fff;
    flex-basis: 49%;
    border-radius: 10px;
    border: 1px solid var(--line);
  }
}
</style>
